import { execFile, spawn, type ExecFileOptions } from 'node:child_process';
import { promisify } from 'node:util';
import { GitOperationAbortedError, throwIfGitShutdownRequested, trackGitChildProcess } from './git-runtime.js';
import { isCliImmediateShutdownRequested } from '../runtime/cli-process-interrupt.js';

const execFileAsync = promisify(execFile);

export async function execGitFile(
  args: string[],
  options: ExecFileOptions & { cwd: string },
): Promise<{ stdout: string; stderr: string }> {
  throwIfGitShutdownRequested();
  try {
    const result = await execFileAsync('git', args, {
      maxBuffer: 10 * 1024 * 1024,
      ...options,
    });
    throwIfGitShutdownRequested();
    return {
      stdout: String(result.stdout ?? ''),
      stderr: String(result.stderr ?? ''),
    };
  } catch (e) {
    if (isCliImmediateShutdownRequested()) {
      throw new GitOperationAbortedError();
    }
    throw e;
  }
}

export function spawnGit(
  args: string[],
  options: { cwd: string },
): ReturnType<typeof spawn> {
  throwIfGitShutdownRequested();
  const child = spawn('git', args, {
    cwd: options.cwd,
    stdio: ['ignore', 'pipe', 'pipe'],
  });
  trackGitChildProcess(child);
  return child;
}
